import React, { useEffect, useState } from "react";

/**
 * Tiny celebration overlay that fires once for ~1.4 seconds.
 * Renders a soft green check + a few drifting particles.
 * Pass `trigger` (any changing value) to fire again.
 */
const ReceiveCelebration = ({ trigger }) => {
  const [active, setActive] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    if (!trigger) return;
    setKey((k) => k + 1);
    setActive(true);
    const t = setTimeout(() => setActive(false), 1400);
    return () => clearTimeout(t);
  }, [trigger]);

  if (!active) return null;

  // 14 confetti pieces with randomised paths
  const pieces = Array.from({ length: 14 }).map((_, i) => {
    const x = (Math.random() - 0.5) * 320;
    const y = -Math.random() * 220 - 60;
    const rot = (Math.random() - 0.5) * 720;
    const delay = Math.random() * 0.18;
    const colors = ["#5FBE7E", "#228EBF", "#7A4DBA", "#FFB300", "#107A3E"];
    return (
      <span
        key={`${key}-${i}`}
        className="confetti-bit"
        style={{
          "--tx": `${x}px`,
          "--ty": `${y}px`,
          "--rot": `${rot}deg`,
          animationDelay: `${delay}s`,
          background: colors[i % colors.length],
        }}
      />
    );
  });

  return (
    <div
      key={key}
      className="fixed inset-0 z-[80] pointer-events-none flex items-center justify-center"
      data-testid="receive-celebration"
    >
      <div className="relative w-0 h-0">
        <div className="check-bubble">
          <svg viewBox="0 0 52 52" className="check-svg">
            <circle cx="26" cy="26" r="22" />
            <path d="M14 27 l8 8 l16 -18" />
          </svg>
        </div>
        {pieces}
      </div>
    </div>
  );
};

export default ReceiveCelebration;
